import Animation from './animation'

/*
 * Animation runs when there is a sliding left/right x-axis
 */
class SlidingAnimation extends Animation {

  match (serie) {
    if (!this.previous.scalers.x || this.seriesChanged) {
      // We don't have previous data or series changed, so we're not sliding
      return false
    }
    let domain0 = this.previous.scalers.x.groupScale.domain()
      , domain1 = this.scalers.x.groupScale.domain()
      , plot0 = this.previous.scalers.x.plotScale.domain()
      , plot1 = this.scalers.x.plotScale.domain()

    return domain0[0] !== domain1[0] || // Start ticks don't match
           domain0[domain0.length - 1] !== domain1[domain1.length - 1] || // End ticks don't match
           plot0.every((id, i) => id != plot1[i])

  }

  _slideOut (selection) {
    let scale0 = this.previous.scalers.x.groupScale
      , scale1 = this.groupScale
      , domain0 = scale0.domain()
      , domain1 = scale1.domain()

    scale0.paddingInner(0)

    selection.attr('transform', d => {
      let idx = domain0.indexOf(d.id)
        , prevStart = domain0.indexOf(domain1[0])
        , prevEnd = domain0.indexOf(domain1[domain1.length - 1])
        , step = scale1.step()
        , x

      if (idx < prevStart) {
        // Slide this out to the left
        x = -step * (prevStart - idx)
      } else {
        // Slide this to the right
        x = (step * (idx - prevEnd))
      }

      return `translate(${x})`
    })
    .remove()
  }

  /*
   * Override the start x locations so we can slide in from the left or right
   */
  _getStartXExent (rangeId, seriesRefId) {
    let scale0 = this.previous.scalers.x.groupScale
      , scale1 =this.groupScale
      , domain0 = scale0.domain()
      , domain1 = this.groupScale.domain()
      , idx = domain1.indexOf(rangeId)
      , prevStartIdx = domain1.indexOf(domain0[0])
      , prevEndIdx = domain1.indexOf(domain0[domain0.length - 1])
      , prevEndLocation = scale0(domain0[domain0.length - 1])
      , step = scale0.step()
      , x

    if (idx < prevStartIdx) {
      // From left
      x = step * (idx - prevStartIdx) //+ scale0() //this.groupScale.bandwidth() * (idx - prevStartIdx)
    } else {
      // From right
      x = step * (idx - prevEndIdx) + prevEndLocation
    }

    x += this.refSerieScale(seriesRefId)

    return [x, x + this.refSerieScale.bandwidth()]
  }

  animate (serie, enter, selection, merged, exit) {
    let _selection = merged.selection() // All elements

    this._fills(_selection, merged)
    this._lines(_selection, merged)

    exit.call(this._slideOut.bind(this))
  }

}

export default SlidingAnimation
